// src/data/projects.js
const projects = [
    {
      id: 'portfolio',
      title: 'Personal Portfolio Project',
      shortDescription: 'Portfolio site to showcase some of the skills that I have.',
      fullDescription: 'I built this portfolio site as a hands-on project to learn and practice React.js and Tailwind CSS. It showcases my ability to create responsive, modern web interfaces while deepening my understanding of component-based design and utility-first styling.',
      image: 'https://i.imgur.com/PmJ4G7v.png',
      usedTools: 'React JS and TailwindCSS'
    },
  ];
  
  export default projects;
  